export const subjectLimit: Readonly<number> = 100;
export const basicFieldLimit: Readonly<number> = 50;
export const gidMaxLength: Readonly<number> = 8;

export const projectPrefix: Readonly<'cod'> = 'cod';
